module.exports = __webpack_public_path__ + "img/removeQuestion.da554e62.png";